import React from "react";
import Input from "../../../../../components/FormComponents/Input";
import { MasterDataSelections } from "../../../EditFieldAttribute/EditFieldMasterData";
import CartVariableMapping from "../../../EditFieldAttribute/FieldVariableMapping";
import SubFormSelection from "../../../EditFieldAttribute/SubFormSelection";
import SelectTableId from "../../../SelectTableId";
import { getLabelForKey } from "../../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditRichGrid = (props) => {
  const { editFieldData, setEditFieldData, tableID } = props;

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  const handleChangeSubForm = (data) => {
    setEditFieldData({ ...editFieldData, ...data });
  };
  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        type="checkbox"
        label={getLabelForKey("is_card_format")}
        checked={editFieldData.is_card_format}
        name="is_card_format"
        onChange={({ target }) => handleChangeInput(target.name, target.checked)}
      />
      <MasterDataSelections
        selectedMasterData={editFieldData.master_data || ""}
        onChange={(data) => handleChangeInput("master_data", data)}
        selectedTypes={["grid"]}
      />
      <SelectTableId
        label={getLabelForKey("import_cart")}
        name="import_cart"
        value={editFieldData.import_cart}
        onChange={(name, value) => handleChangeInput(name, value)}
        currentTableId={tableID}
        fiedlType={editFieldData.type}
      />
      <SubFormSelection value={editFieldData.sub_form} onChange={handleChangeSubForm} tableID={tableID} />
      <CartVariableMapping
        cartMapping={editFieldData.cart_mapping}
        onChange={(newMapping) => handleChangeInput("cart_mapping", newMapping)}
        subformId={editFieldData.sub_form}
        cartId={editFieldData.import_cart}
      />
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditRichGrid;
